import React, { useState } from 'react';
import './PlaylistLibrary.css';

export default function PlaylistLibrary({ savedPlaylists, onLoadPlaylist, onDeletePlaylist }) {
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all'
    ? savedPlaylists
    : savedPlaylists.filter(p => p.category === filter);

  const categories = ['all', 'mood', 'activity', 'genre', 'custom'];

  return (
    <div className="playlist-library">
      <h3>📚 我的播放列表库</h3>
      {savedPlaylists.length === 0 ? (
        <div className="empty-library">
          <span className="empty-icon">📂</span>
          <p>还没有保存的播放列表</p>
          <p className="hint">生成播放列表后点击"保存"按钮</p>
        </div>
      ) : (
        <>
          <div className="library-filters">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat === 'all' ? '全部' : cat === 'mood' ? '心情' : cat === 'activity' ? '活动' : cat === 'genre' ? '流派' : '自定义'}
              </button>
            ))}
          </div>
          <div className="library-list">
            {filtered.map(pl => (
              <div key={pl.id} className="library-item">
                <div className="library-item-info">
                  <h4>{pl.name}</h4>
                  <p>{pl.songs.length} 首歌 · {pl.createdAt}</p>
                  <div className="library-item-tags">
                    {pl.tags.map(tag => (
                      <span key={tag} className="lib-tag">{tag}</span>
                    ))}
                  </div>
                </div>
                <div className="library-item-actions">
                  <button className="load-btn" onClick={() => onLoadPlaylist(pl)}>▶ 播放</button>
                  <button className="delete-btn" onClick={() => onDeletePlaylist(pl.id)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
